import React from 'react';
import clsx from 'clsx';
import { makeStyles, Typography, TypographyProps } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    color: theme.palette2.text.secondary,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '24px',
    [theme.breakpoints.up('md')]: {
      fontSize: 16
    },
    '&.primary': {
      color: theme.palette2.text.primary
    },
    '&.subtext': {
      color: theme.palette2.text.subtext
    },
    '&.white': {
      color: theme.palette2.text.paper
    }
  }
}));

interface TextProps extends TypographyProps {
  children?: React.ReactNode;
  className?: string;
}

const Text: React.FC<TextProps> = ({ className = '', children, ...rest }) => {
  const classes = useStyles();

  return (
    <Typography className={clsx(classes.root, className)} {...rest}>
        {children}
    </Typography>
  );
};

export default Text;
